module.exports = __webpack_public_path__ + "img/kep3.a1b2c9a5.jpg";